import Accordion from './accordion';

export default Accordion;
